import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import './App.css';

function FAQ() {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);
  const [searchWallet, setSearchWallet] = useState('');

  const handleSearch = () => {
    const wallet = searchWallet.trim();
    if (wallet) {
      navigate(`/dev/${encodeURIComponent(wallet)}`);
      setSearchWallet('');
    }
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Why does this site exist?",
      answer: "Look, we're tired of getting rugged. Too many devs launch coins, pump them, and then dump on you faster than you can say 'wen moon?'. We built DevRadar to track which developers actually mean business. When a dev pays for DEX listing, that's a signal. It means they're putting real money behind their project. We track this in real-time so you can spot the serious builders from the serial dumpers. Simple as that."
    },
    {
      question: "What features do you have?",
      answer: "We've got the works, my friend! 🚀 Real-time tracking of all new dev launches, DEX payment status monitoring, comprehensive developer leaderboards with bonding rates and market cap stats, detailed dev profiles showing their entire launch history, and live market cap updates that refresh automatically. Plus, we're constantly adding new features. This isn't your grandma's token tracker - we're building the ultimate memecoin intelligence platform."
    },
    {
      question: "What's this DEX payment thing about?",
      answer: "Great question! When developers pay for DEX listing (like DexScreener), they're putting actual money on the line. Think about it - if you're just going to dump and run, why would you pay for listing? You wouldn't. So when we see a coin with DEX paid status, that's a bullish signal. We track this in real-time and show you which coins have paid, which are pending, and when they paid. It's like a credibility score, but for memecoins."
    },
    {
      question: "How do you track all this data?",
      answer: "We're running 24/7 monitoring systems that track every new launch on Pump.fun, monitor market caps in real-time via ZMQ streams, check DEX payment status every minute, and aggregate developer statistics from thousands of launches. Our backend is constantly syncing data, and our frontend updates in real-time via WebSocket connections. No manual work, no delays - just pure, automated memecoin intelligence."
    },
    {
      question: "What's a bonding rate and why should I care?",
      answer: "Bonding rate is the percentage of a developer's launches that actually reach bonding (the point where liquidity moves to Raydium). Higher bonding rate = more serious developer. If someone launches 10 coins and only 1 bonds, that's a 10% bonding rate - not great. But if they launch 10 and 8 bond? That's an 80% bonding rate - now we're talking! We track this for every developer so you can see who's actually building vs. who's just spamming launches."
    },
    {
      question: "Is this free to use?",
      answer: "Absolutely! DevRadar is completely free to use. We believe in open access to memecoin intelligence. No paywalls, no premium tiers, no BS. Just pure, unfiltered data delivered in real-time. We're building this for the community, by the community. And speaking of community..."
    },
    {
      question: "You mentioned launching your own coin?",
      answer: "You bet! 🎯 We're launching our own token on Solana soon. This isn't just a side project - we're putting our money where our mouth is. The token will have real utility tied to the platform, governance rights, and exclusive features for holders. We're building something sustainable here, not another pump-and-dump. Stay tuned - when we launch, you'll know about it first because we'll be tracking ourselves on our own platform. That's how confident we are in what we're building."
    },
    {
      question: "How accurate is your data?",
      answer: "We pull data directly from on-chain sources, Pump.fun's API, DexScreener's API, and our own real-time monitoring systems. Everything is cross-referenced and validated. Market caps update every few seconds, DEX status checks happen every minute, and developer stats are recalculated continuously. We're not guessing - we're tracking actual blockchain data. If it's on-chain, we see it."
    },
    {
      question: "Can I trust the developer rankings?",
      answer: "Our leaderboard is based on hard data: total launches, bonding rates, average market caps, peak performances. We don't do subjective rankings or paid placements. If a dev is at the top, it's because their numbers put them there. We show you the metrics, you make the decisions. Transparency is key - that's why we show you everything: bonding rates, market cap history, launch frequency. No hidden algorithms, no secret sauce - just raw, honest data."
    },
    {
      question: "What's next for DevRadar?",
      answer: "We're just getting started! 🔥 Coming soon: advanced filtering and alerts, portfolio tracking, price predictions based on dev history, social sentiment analysis, and much more. Plus, our own token launch with exclusive features for holders. We're building the ultimate memecoin research platform, and we're doing it the right way - with real utility, real data, and real transparency. This is going to be huge. You're early."
    },
    {
      question: "How can I stay updated?",
      answer: "Bookmark this page, follow our updates, and get ready for our token launch! We're building in public, adding features constantly, and always listening to the community. When we launch our token, holders will get exclusive access to premium features, early access to new tools, and governance rights. This isn't just a tracker - it's becoming a movement. Join us."
    }
  ];

  return (
    <div className="App">
      <Header />

      <main className="app-main">
        <div className="page-header">
          <h2 className="page-title">Frequently Asked Questions</h2>
          <p className="page-subtitle">
            Everything you need to know about DevRadar, memecoin tracking, and why we're building the future of token intelligence.
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
              onClick={() => toggleAccordion(index)}
            >
              <div className="faq-question">
                <span className="faq-question-text">{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default FAQ;

